import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "reduxStore";

/**
 * @description Redux selector with types added
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
